export default __webpack_public_path__ + "static/award-pe-882c944929473f527a77013903105f08.png";